import React from "react";
import "../post.css";
import DaySeven from "../images/day_seven.jpg";

export default class Post extends React.Component {
  render() {
    return (
      <div className="card">
        <h2 className="header">Day Seven</h2>
        <img className="image" alt="itinerary" src={DaySeven} />
        <div className="infobar">
          <div className="info">26 Nov 2018</div>
        </div>
        <h3>Morning</h3>
        <p>
          Osaka Aquarium Kaiyukan. The aquarium is several stories tall. There
          are sea animal shows scheduled throughout the day.
        </p>
        <h3>Afternoon</h3>
        <p>
          Head to Osaka Castle after that. There is an observatory at the
          top-most deck.
        </p>
        <h3>Night</h3>
        <p>
          Back to Dotonbori for dinner. Karaoke Pasera Dotonbori has a dessert
          cafe that serves Honey Toast.
        </p>
      </div>
    );
  }
}
